export default {
    ReadMasterProps(action, self, ReadMasterSuccess, ReadMasterFailed){
        return {
            data : {
              query              : self.state.query,
              AuthorizationToken : self.props.UserReducer.token,
            },
            action    : action,
            self      : self,
            onsuccess : ReadMasterSuccess,
            onfailed  : ReadMasterFailed,
        }
    },
    Update(self, UpdateSuccess, UpdateFailed) {
       return {
           data : {
             GlobalMaxDay       : self.state.GlobalMaxDay.toString(),
             Urgency            : self.state.UrgencyDay.toString(),
             StorageType        : self.state.StorageType.value,
             MaintenanceType    : self.state.MaintenanceType.value,
             MaintenanceStatus  : self.state.MaintenanceStatus.value,
             StorageStatus      : self.state.StorageStatus.value,
             InactiveStatus     : self.state.InactiveStatus.value,
             BusyStatus         : self.state.BusyStatus.value,
             BrokenStatus       : self.state.BrokenStatus.value,
             LostStatus         : self.state.LostStatus.value,
             AdminRole          : self.state.AdminRole.value,
             StorageRole        : self.state.StorageRole.value,
             DefaultCurrency    : self.state.DefaultCurrency.value,
             SingleCurrency     : self.state.SingleCurrency.toString(),
             CoverageCity       : self.state.CoverageCity,
             AuthorizationToken : self.props.UserReducer.token,
           },
           self      : self,
           onsuccess : self.UpdateSuccess,
           onfailed  : self.UpdateFailed,
       }
    }

}



// WEBPACK FOOTER //
// ./src/App/master/tenant_setting/helper/request.props.js